import React from 'react';
import { Grid, GridProps } from '@mui/material';

export interface IUIFlexProps extends GridProps {
  jc?: GridProps['justifyContent'];
  ai?: GridProps['alignItems'];
}

const UIFlex: React.FC<IUIFlexProps> = ({
  jc = 'space-between',
  ai = 'center',
  children,
  ...props
}) => {
  return (
    <Grid container justifyContent={jc} alignItems={ai} {...props}>
      {children}
    </Grid>
  );
};

export default UIFlex;
